import React from 'react';
import {connect} from 'react-redux';
import {match} from 'react-router-dom';
import {CircleLoader} from 'react-spinners';
import {css} from '@emotion/core';
import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';

import PostMeta from '../Components/PostMeta';
import CategoryPanel from '../Components/CategoryPanel';
import Markdown from '../Components/Markdown';
import Crumb from '../Components/Crumb';
import {Article} from '../Services/ArticleService';
import {AppState} from '../Store';
import {setArticleCreator} from '../Store/Articles/Actions';

type TParams = {
  id?: string
};

interface ArticleProps {
  article?: Article;
  loading: boolean;
  match: match<TParams>;

  setArticle: (id: number) => Promise<void>;
}

function ArticleDetail({article, loading, match, setArticle}: ArticleProps) {
  if (loading) {
    return (
      <CircleLoader
        css={css`
          display: block;
          margin: 0 auto;
        `}
      />
    );
  }

  if (article === undefined) {
    const {params: {id}} = match;
    if (id !== undefined) {
      setArticle(Number(id));
    }
    return <div />;
  }

  return (
    <div className="single-blog-content mb-100">
      <h5 className="title">
        <Crumb to="/public">Back to News</Crumb>
      </h5>
      <div className="post-content">
        <Markdown source={article.body} />
        <ul className="post-tags">
          <CategoryPanel categories={article.categories} />
        </ul>
        <PostMeta article={article} footer={true} breadcrumb={false} />
      </div>
    </div>
  );
}

const mapStateToProps = (state: AppState) => ({
  article: state.articles.article,
  loading: state.articles.loading,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    setArticle: (id: number) => dispatch(setArticleCreator(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArticleDetail);
